package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_05_19_Day_1
import com.veldekar.components.logs.Log_2023_05_19_Day_2
import com.veldekar.components.logs.Log_2023_05_19_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-05-19")
@Composable
public fun Log_2023_05_19(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Entering the Darkway",
        ogTitle = "Entering the Darkway",
        date = LocalDate(2_023, 5, 19),
        ogDescription = "The heroes enter the Malusian Imperial Darkway, facing Vrocks in an abandoned guard outpost deep underground.",
        ogImage = "ai/2023-05-19.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-26", dateString = "Newgrowth 26")
        Log_2023_05_19_Day_1()
        SessionDayHeader(dayId = "newgrowth-27", dateString = "Newgrowth 27")
        Log_2023_05_19_Day_2()
        SessionDayHeader(dayId = "newgrowth-28", dateString = "Newgrowth 28")
        Log_2023_05_19_Day_3()
    }
}
